import React from 'react';
import { LayoutOrientations } from '../../globals';

/**
 * renders a line used to separate areas of other components into logical sections for organization
 * @export
 * @param {{
 * orientation: LayoutOrientations,
 * className: String,
 * style: {}
 * }} props these special props may be used:
 * - orientation: defines the direction in which the line will be drawn, either Vertical or Horizontal. *defaults to Vertical*
 * - className: an additional CSS class name to apply to the root div
 * - style: additional CSS properties to add or override the default styling
 * @returns a basic line that stretches to the size of its container
 */
export default function Separator(props: { 
	orientation?: LayoutOrientations; 
	className?: string; 
	style?: React.CSSProperties;
	disabled?: boolean;
})
{
	const orientation = props.orientation ? props.orientation : LayoutOrientations.Vertical;

	return (
		<div className={[
			"separator",
			(orientation),
			(props.className ? props.className : ""),
		].join(' ')}
		style={props.style}
		/>
	);
}